
export function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}


export function speedBump(e, text, linkURL) {
  if(!linkURL.includes("citibank.com")){
    if(!window.confirm(text)) e.preventDefault(); 
  }  
}

export function makeid(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export function separateSystemTypes(data) {
  const systemArray = [];
  const productArray = [];

  data.forEach(item => {
    if (item.systemType === 'product') {
      productArray.push(item);
    } else {
      systemArray.push(item);
    }
  });

  return { systemArray, productArray };
}